import React, { Component } from 'react';
import { Search } from 'carbon-components-react';
import { TableDefault } from '../../../components';




class ConsultantsVersosStatus extends Component {

  constructor(props) {
    super(props)
    this.state = {
      search: "",
      pageSize: 100,
      totalItems: 0,
      orderBy: 'default',
      order: '',
      urlLoad: 'Dashboard/Agencia/ListagemSolicitantes',
      page: 1,
      urlCurrent: ""
    }
  }

  onSearchChange = event => {
    clearTimeout(this.searchTimeout);

    
    const { value } = event.target;
    this.setState({ search: value, page: 1 });
    const text = value !== undefined ? value : ""
    
    this.searchTimeout = setTimeout(() => {
      this.setState(
        {
          search: text || "",
          urlCurrent: `busca=${text}`,
          page: 1
        }, () => {
          this.tableList.getItems();
        });
    }, 1800);
  };


  render() {
    const {
      search,
      pageSize,
      totalItems,
      order,
      orderBy,
      urlLoad,
      urlCurrent,
      page
    } = this.state;

    const notSearch = true;

    return (
      <div>
        <div className="bx--row table-consultants-versus-status">
          <div className="bx--col-md-4 bx--col-xs-12 bx--col-sm-12 ">
            <h2>
              Solicitantes x Status de Pedidos
            </h2>
          </div>
          <div className="bx--col-md-8 bx--col-sm-12 bx--col--xs-12">
            <Search
              className="search-request-agency campoPedido some-class"
              id="search-1"
              name="busca"
              defaultValue=""
              onChange={e => this.onSearchChange(e)}
              labelText="Buscar Consultor"
              placeHolderText="Buscar Consultor"
            />
          </div>
        </div>
        <div className="bx--row">

          <div className="bx--col-md-12 bx--col-xs-12 bx--col-sm-12">
            <div className="consultants-versos-status">
              <TableDefault
                notSearch={notSearch}
                params={urlCurrent}
                search={search}
                order={order}
                orderBy={orderBy}
                page={page}
                pageSize={pageSize}
                totalItems={totalItems}
                urlLoad={urlLoad}
                displayActions={false}
                onRef={ref => {
                  this.tableList = ref;
                }}
              />
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default ConsultantsVersosStatus



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/consultants-versos-status.js